
import { computed, defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { ApiOrderRequest } from "@/core/api";
import { OrderRequestV2ItemTable } from "@/core/directive/interface/orderRequest";
import CommonProduct from "./CommonProduct.vue";
import {
  getOrderItemAmountTotal,
  getOrderItemVatTotal,
} from "@/core/directive/function/order";

export default defineComponent({
  name: "kt-order-request-item-v2-table",
  props: {
    id: {
      type: Number || String,
      required: true,
      default: "",
    },
  },
  components: {
    CommonProduct,
  },
  setup(props) {
    const { t } = useI18n();

    const loading = ref<boolean>(false);
    const isRequest = ref<boolean>(false);
    const tableData = ref<Array<OrderRequestV2ItemTable>>([]);

    const options = ref({});

    const getItemAmountTotal = computed(() => {
      return (
        confirmedQty: number,
        unitPrice: number,
        discountPrice: number,
        discountType: number,
        taxCount: number,
        isTaxCount = true
      ) => {
        return getOrderItemAmountTotal(
          confirmedQty,
          unitPrice,
          discountPrice,
          discountType,
          taxCount,
          isTaxCount
        );
      };
    });

    const getItemVatTotal = computed(() => {
      return (
        confirmedQty: number,
        unitPrice: number,
        discountPrice: number,
        discountType: number,
        taxCount: number,
        isTaxCount = true
      ) => {
        return getOrderItemVatTotal(
          confirmedQty,
          unitPrice,
          discountPrice,
          discountType,
          taxCount,
          isTaxCount
        );
      };
    });

    const getOrderRequestItemInfo = async () => {
      loading.value = true;
      const { data } = await ApiOrderRequest.getOrderRequestItemV2Info({
        merchant_request_id: props.id,
      });
      loading.value = false;
      if (data.code == 0) {
        tableData.value = data.data;
      }
    };

    onMounted(() => {
      getOrderRequestItemInfo();
    });

    return {
      t,
      loading,
      props,
      tableData,
      isRequest,
      options,
      getItemAmountTotal,
      getItemVatTotal,
    };
  },
});
